<template>
    <div class="h-full w-full relative flex items-center justify-center earn-shake">
      <img :src="imageUrl" class="relative z-[4] h-full object-contain" />
      <img
        src="@/assets/images/item-back-shadow.svg"
        class="absolute w-[400px] z-[2] top-1/2  -translate-y-1/2 left-1/2 -translate-x-1/2"
      />
    </div>
  </template>
  
<script setup>
import { computed } from 'vue';

const props = defineProps({
  item: {
    type: String,
    required: false,
    default:''
  },
  image: {
    type: String,
    required: false,
    default: '0.svg'
  }
});
const imageUrl = computed(()=>{
  if (props.item === '') {
    return new URL(`../assets/images/skins/${props.image}`, import.meta.url).href
  }
  return new URL(`../assets/images/skins/${props.item}.svg`, import.meta.url).href
}) 
</script>
